export default __webpack_public_path__ + "static/media/thumb.204314f9.svg";